import React from 'react'
import { CardDashboardWidgetCP } from 'main/modules/dashboard/components/card-dashboard-widget/CardDashboardWidgetCP'
import { DashboardRequests } from 'main/modules/dashboard/services/DashboardRequests'
import { WidgetLeadEnum } from 'main/modules/dashboard/services/enums/WidgetLeadEnum'

interface ICPProps {
    userCode?: number
    franchiseCodes?: number[]
}

/**
 * Widgets de total de leads abertos que tem atividade atrasada.
 */
export function WidgetTotalLeadsDelayedCP(props: ICPProps): JSX.Element {

    return (
        <CardDashboardWidgetCP
            title={'Leads atrasados'}
            help={'Total de LEADs que possui atividades em atraso'}
            isZeroTarget={true}
            requestConfigGetter={
                DashboardRequests.getLeadWidgets(
                    WidgetLeadEnum.DELAYEDS,
                    { userCode: props.userCode, franchiseCodes: props.franchiseCodes }
                )
            }
        />
    )
}
